const QUIZ_FORM_ID = "sleep-fit-quiz"
KLAVIYO_LIST_ID = "W5HKfQ"

const _regular = {
    options: {
        variantId: '45562160119973',
        product: 'natural-sleep-drops',
        product_name: 'Regular Strength Sleep Drops',
        title: 'We recommend our best-selling Natural Sleep Drops',
        subtitle: '',
        image: 'https://cdn.shopify.com/s/files/1/0554/8087/7221/files/regular.webp?v=1740178336',
    },
    pdp: {
        discountCode: '',
        discountPercent: '',
        href: '/products/natural-sleep-drops',
    },
    lander: {
        href: '/pages/products/sleep-drops-1',
        discountCode: '',
        discountPercent: '58%',
        placeholder: 'Enter email to get 58% off your order today'
    },
}


function calculateLP(alpine) {
    alpine.results = {
        ..._regular.options,
        ...(alpine.isLander ? _regular.lander : _regular.pdp)
    }


    const subtitle = formatResultsSub([
        {
            result: alpine.formDataOutput.winding_down,
            value: 'Winding Down'
        },
        {
            result: alpine.formDataOutput.falling_asleep,
            value: 'Falling Asleep'
        },
        {
            result: alpine.formDataOutput.staying_asleep,
            value: 'Staying Asleep'
        }, {
            result: alpine.formDataOutput.recover_fully,
            value: 'Recovering Fully'
        }
    ])

    const formatedSubtitle = `<p>Our Sleep Drops are designed for anyone who stuggles with ${subtitle}</p>`
    if (subtitle) {
        alpine.results.subtitle = formatedSubtitle
    }

}

function isStepValid(handle, alpine) {

    switch (handle) {
        case 'sleep-score':
            return alpine.formDataOutput.sleep_score
        case 'sleep-products-tried':
            return alpine.formDataOutput.sleep_products_tried.length >= 1
        case 'supplement-sensitivity':
            return alpine.formDataOutput.supplement_sensitivity.length >= 1
        case 'age':
            return alpine.formDataOutput.age
        case "winding-down":
            return alpine.formDataOutput.winding_down.length >= 1
        case "falling-asleep":
            return alpine.formDataOutput.falling_asleep.length >= 1
        case "staying-asleep":
            return alpine.formDataOutput.staying_asleep.length >= 1
        case "recover-fully":
            return alpine.formDataOutput.recover_fully.length >= 1
        default:
            false;
    }
}